import styles from './Article.style';

class Article extends React.Component {
  render() {
    const { classes, children, className, noPadding } = this.props;

    return (
      <div
        className={classnames(classes.root, className, {
          [classes.noPadding]: noPadding,
        })}>
        {children}
      </div>
    );
  }
}

export default withStyles(styles)(Article);
